package cz.lhoracek.mapl.data.model

import kotlinx.serialization.Serializable

@Serializable
data class Player(
    val id: String,
    val name: String,
    val color: String = "#E53935",
    val score: Int = 0,
)
